import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

interface JobProfitBadgeProps {
    grossProfit: number;
    marginPercent: number;
    loading?: boolean;
}

export function JobProfitBadge({ grossProfit, marginPercent, loading }: JobProfitBadgeProps) {
    if (loading) return <div className="h-6 w-20 bg-tint/5 animate-pulse rounded"></div>;

    // Determine status color
    let colorClass = 'bg-raised text-fg-3 border-line-strong';
    let Icon = Minus;

    if (marginPercent >= 30) {
        colorClass = 'bg-success/10 text-success border-success/20';
        Icon = TrendingUp;
    } else if (marginPercent >= 10) {
        colorClass = 'bg-gold-fill/10 text-gold border-gold/20';
        Icon = TrendingDown; // Still down relative to target
    } else { // < 10% or negative
        colorClass = 'bg-danger/10 text-danger border-danger/20';
        Icon = TrendingDown;
    }

    const formatCurrency = (amount: number) =>
        new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0 }).format(amount);

    return (
        <div className={`flex items-center gap-2 px-2 py-1 rounded border text-xs font-bold ${colorClass}`} title={`Margin: ${marginPercent}%`}>
            <Icon className="w-3 h-3" />
            <span>{formatCurrency(grossProfit)}</span>
            <span className="opacity-60 text-[10px] ml-0.5">({marginPercent}%)</span>
        </div>
    );
}
